import { useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Bold, Heading, List } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Basit biçim: "# " başlık, "- " madde, **kalın**
const inline = (t, k) => t.split(/(\*\*[^*]+\*\*)/g).map((p, i) => (p.startsWith('**') && p.endsWith('**') ? <strong key={`${k}-${i}`}>{p.slice(2, -2)}</strong> : p));

export const CommitmentText = ({ content = '' }) => {
  const out = [];
  let list = [];
  const flush = (k) => { if (list.length) { out.push(<ul key={`ul-${k}`} className="my-2 list-disc space-y-1 pl-6">{list}</ul>); list = []; } };
  content.split('\n').forEach((line, i) => {
    if (line.startsWith('- ')) { list.push(<li key={i}>{inline(line.slice(2), i)}</li>); return; }
    flush(i);
    if (line.startsWith('# ')) out.push(<h3 key={i} className="mt-4 mb-1 text-base font-bold text-slate-900">{inline(line.slice(2), i)}</h3>);
    else if (line.trim()) out.push(<p key={i} className="my-1.5 leading-relaxed">{inline(line, i)}</p>);
  });
  flush('end');
  return <div className="text-sm text-slate-700" data-testid="commitment-text">{out}</div>;
};

export const CommitmentEditor = ({ value, onChange }) => {
  const ref = useRef(null);
  const wrap = (before, after = '') => {
    const el = ref.current;
    const [s, e] = [el.selectionStart, el.selectionEnd];
    onChange(value.slice(0, s) + before + value.slice(s, e) + after + value.slice(e));
    setTimeout(() => { el.focus(); el.setSelectionRange(s + before.length, e + before.length); }, 0);
  };
  const lineStart = (mark) => {
    const s = ref.current.selectionStart;
    const ls = value.lastIndexOf('\n', s - 1) + 1;
    onChange(value.slice(0, ls) + mark + value.slice(ls));
  };
  const btn = 'inline-flex h-8 items-center gap-1 rounded-md border bg-white px-2 text-xs font-semibold text-slate-700 hover:bg-slate-100';
  return (
    <div className="rounded-lg border">
      <div className="flex gap-1 border-b bg-slate-50 p-1.5">
        <button type="button" className={btn} onClick={() => lineStart('# ')} data-testid="editor-heading-btn"><Heading className="h-3.5 w-3.5" />Başlık</button>
        <button type="button" className={btn} onClick={() => wrap('**', '**')} data-testid="editor-bold-btn"><Bold className="h-3.5 w-3.5" />Kalın</button>
        <button type="button" className={btn} onClick={() => lineStart('- ')} data-testid="editor-list-btn"><List className="h-3.5 w-3.5" />Madde</button>
      </div>
      <textarea ref={ref} value={value} onChange={(e) => onChange(e.target.value)} rows={14} data-testid="commitment-content-input"
        className="block w-full resize-y rounded-b-lg p-3 font-mono text-sm outline-none" placeholder={'# Genel Kurallar\n- Çalışma alanında baret ve yelek zorunludur.\n- **Sıcak çalışma** öncesi izin alınmalıdır.'} />
    </div>
  );
};

export const openCommitmentPdf = (id, firm) => axios.get(`${API}/${firm ? 'firm/isg-commitment' : 'isg-commitments'}/file/${id}`, { responseType: 'blob' })
  .then(r => window.open(URL.createObjectURL(r.data), '_blank')).catch(() => toast.error('PDF açılamadı'));
